import React, { useState, useEffect, useRef, useMemo, Suspense } from 'react';
import { useTable, usePagination, useSortBy, useGlobalFilter } from 'react-table';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Resizable } from 're-resizable';
import ReactPaginate from 'react-paginate';
import { Navigate } from 'react-router-dom';
import defaultLogo  from './Logo iAnalytics.png'; // Importeer je standaard logo (iAnalytics)
import icon1 from './My Apps Icon.png'; // Importeer de icoontjes
import icon2 from './My Account Icon.png';
import icon_Analyses from './Icon Analyses App.png';
import icon_Trainings from './Icon Trainings App.png';
import icon_CustomerPortal from './Icon Customer Portal App.png';
import icon_EmployeePortal from './Icon Employee Portal App.png';
import icon_SupplierPortal from './Icon Supplier Portal App.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_Warning from './Icon Warning.png';
import icon_MoreOptions from './Icon More Options.png';
import icon_EditReport from './Icon Edit.png';
import icon_CustomApplicationModules from './Custom Application Modules Icon.png';
import icon_Refresh from './Icon Refresh.png';
import icon_UpdateReport from './Icon Update.png';
import toggle_menu_icon from './Toggle Menu Icon.png';
import { useAuth } from './AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import './Main.css';
import './Forms.css';
import icon_ConfigCompany from './Icon Config Company.png';
import icon_DeleteReport from './Icon Recycle Bin.png';
import Gantt from "frappe-gantt";
import 'frappe-gantt/dist/frappe-gantt.css';
import $ from 'jquery'; // Importeer jQuery
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';
import api from './axios';

import SupplierPortal, { SPConnectionAndSecurity, SPGeneralSettings, InviteSuppliersTable, SupplierPortalContent, ManageInvitedSuppliers } from './SupplierPortal';
import EmployeePortal, { EPConnectionAndSecurity, EPGeneralSettings, InviteEmployeesTable, EmployeePortalContent, ManageInvitedEmployees } from './EmployeePortal';
import CustomerPortal, { CPConnectionAndSecurity, CPGeneralSettings, InviteCustomersTable, CustomerPortalContent, ManageInvitedCustomers } from './CustomerPortal';
import { CP_UserPermissionsProvider } from './CPUserPermissionsContext';
import { EP_UserPermissionsProvider } from './EPUserPermissionsContext';
import { SP_UserPermissionsProvider } from './SPUserPermissionsContext';
import Subscriptions from './Subscriptions';

import MenuIconBIReport from './MenuIcon BI Report.png';

import MenuIconConnection from './MenuIcon Connection.png';
import MenuIconGeneral from './MenuIcon Config.png';
import MenuIconAddCustomers from './MenuIcon Add Customers.png';
import MenuIconManageCustomers from './MenuIcon Manage Customers.png';


function Header() {
  const [menu1Open, setMenu1Open] = useState(false);
  const [menu2Open, setMenu2Open] = useState(false);
  const menu1Ref = useRef(null);
  const menu2Ref = useRef(null);
  const iconRef = useRef(null);
  const [popupCoords, setPopupCoords] = useState({ left: 0, top: 0 });
  const contextMenuRef = useRef(null);
  const { user, logout, companyId, companyName, switchCompany, updateUser } = useAuth();
  const navigate = useNavigate(); 
  const [showSideMenu, setShowSideMenu] = useState(true);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [myReports, setMyReports] = useState([]);
  const [myDashboards, setMyDashboards] = useState([]);
  const [selectedPBIReportId, setSelectedPBIReportId] = useState(null);
  const [selectedPBIReport_UrlFilter, setSelectedPBIReport_UrlFilter] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [selectedDashboardId, setSelectedDashboardId] = useState(null);
  const [selectedDashboardUrl, setSelectedDashboardUrl] = useState("");
  const [selectedReportConnectedState, setSelectedReportConnectedState] = useState(1);  // initieel ervan uitgaan dat de connectie er is, zodat de 'bounce' knop (nog) niet getoond wordt
  const [selectedReportActiveState, setSelectedReportActiveState] = useState(1);  // initieel ervan uitgaan dat de licentie actief is, zodat de 'bounce' knop (nog) niet getoond wordt
  const [showOverlay, setShowOverlay] = useState(false);
  const [error, setError] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showPopupMessage, setShowPopupMessage] = useState(false);
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [message, setMessage] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Support');
  const [Request_message, setRequestMessage] = useState("");
  const [showQuestionYesNoPopup, setShowQuestionYesNoPopup] = useState(false);
  const [showQuestionYesNoPopup_UpdateReport, setShowQuestionYesNoPopup_UpdateReport] = useState(false);
  const [showQuestionYesNoPopup_ActivateLicense, setShowQuestionYesNoPopup_ActivateLicense] = useState(false);
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [moreOptionsReportMenuPosition, setMoreOptionsReportMenuPosition] = useState({ x: 0, y: 0 });
  const [moreOptionsReportMenuOpen, setMoreOptionsReportMenuOpen] = useState(null);
  const [clickedMoreOptionsReportId, setClickedMoreOptionsMenuReportId] = useState(null);
  const [reportSrc, setReportSrc] = useState('');
  const [popupLicenseText, setPopupLicenseText] = useState('');

  // Eerst even geen default kiezen, maar alleen wat er in localStorage staat (of null)
  const [selectedAppItem, setSelectedAppItem] = useState(() => {
    return localStorage.getItem('iA-App') || null;
  });

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedCP_MenuItem, setSelectedCP_MenuItem] = useState(null);
  const [selectedCPUser_MenuItem, setSelectedCPUser_MenuItem] = useState(null);
  const [selectedEP_MenuItem, setSelectedEP_MenuItem] = useState(null);
  const [selectedSP_MenuItem, setSelectedSP_MenuItem] = useState(null);
  const [newAppNames, setNewAppNames] = useState([]);
  const [newAppModuleNames, setNewAppModuleNames] = useState([]);
  const [newReportNames, setNewReportNames] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [selectedFormRecordID, setSelectedFormRecordID] = useState(null); // State voor het geselecteerde formulier record Id
  const [logoPath, setLogoPath] = useState(null);
  const fileExtensions = ["png", "jpg", "jpeg", "gif", "bmp"]; // Voeg hier meer extensies toe indien nodig
  const [isLoading, setIsLoading] = useState(false);
  const [CP_userpermissions, setCP_userpermissions] = useState([]); // State voor de Customer Portal User Permissions
  const [showPopup_VisibleColumns, setShowPopup_VisibleColumns] = useState(false); 
  const [popupContent_VisibleColumns, setPopupContent_VisibleColumns] = useState([]);
  const [moduleContent, setModuleContent] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isMenuExpanded, setIsMenuExpanded] = useState(true);


  useEffect(() => {
    if (!user?.company_roleId) return;
  
    // Rol 4 = Customer Portal, rol 5 = Employee Portal, rol 6 = Supplier Portal
    if (user.company_roleId === 4) {
      if (selectedAppItem !== 'Customer Portal') {
        setSelectedAppItem('Customer Portal');
        localStorage.setItem('iA-App', 'Customer Portal');
      }
      return;
    }
    if (user.company_roleId === 5) {
      if (selectedAppItem !== 'Employee Portal') {
        setSelectedAppItem('Employee Portal');
        localStorage.setItem('iA-App', 'Employee Portal');
      }
      return;
    }
    if (user.company_roleId === 6) {
      if (selectedAppItem !== 'Supplier Portal') {
        setSelectedAppItem('Supplier Portal');
        localStorage.setItem('iA-App', 'Supplier Portal');
      }
      return;
    }

    // Voor alle andere rollen: alleen als er nog geen waarde in state staat
    if (!selectedAppItem) {
      const fromStorage = localStorage.getItem('iA-App');
      const defaultApp = fromStorage || 'Analyses';
      setSelectedAppItem(defaultApp);
      localStorage.setItem('iA-App', defaultApp);
    }
  }, [user, selectedAppItem]);



  useEffect(() => {
    (async () => {
      if (!companyId) {
        setLogoPath(null); // Start zonder logo of met een laadindicator
        return;
      }
  
      let found = false;
      for (const ext of fileExtensions) {
        const timestamp = Date.now(); // Voeg een tijdstempel toe om de cache te omzeilen
        const path = `/Media/Company Logos/Logo-${companyId}.${ext}?t=${timestamp}`;
        try {
          const response = await fetch(path);
  
          if (response.status === 200 && response.headers.get('Content-Type').includes('image')) {
            // Afbeelding bestaat
            setLogoPath(path);
            found = true;
            break;
          }
        } catch (error) {
          console.log("Error loading image:", error);
        }
      }
      if (!found) {
        setLogoPath(defaultLogo); // Stel het defaultLogo in als alle aanroepen mislukken
      }
    })();
  }, [companyId]);
  

  const handleImageError = () => {
    setLogoPath(defaultLogo);
  };

  const currencyFormatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  const modules = [
    { name: 'Module Afwijkingenbeheer (NCR)', videoSrc: 'Media/Videos/Ridder iQ Modules, NCR module.mp4' },
    { name: 'Module Digitale Meetrapporten', videoSrc: 'Media/Videos/Ridder iQ Modules, Digitale meetrapporten module.mp4' },
    { name: 'Module Certificatenbeheer', videoSrc: 'Media/Videos/Ridder iQ Modules, Attesten module.mp4' },
    { name: 'Module Smart Calculation', videoSrc: 'Media/Videos/Ridder iQ Modules, Smart Calculation.mp4' },
    { name: 'Module CMR Vervoerdocument', videoSrc: 'Media/Videos/Ridder iQ Modules, CMR Vervoerdocumenten module.mp4' },
    { name: 'Module Beheer Meetmiddelen', videoSrc: 'Media/Videos/Ridder iQ Modules, Beheer meetmiddelen module.mp4' },
  ];

  const CP_menuItems = [
    { name: "Connection and Security", icon: MenuIconConnection },
    { name: "General settings",       icon: MenuIconGeneral    },
    { 
      name: user?.autoLogin ? "Add customers" : "Invite customers", 
      icon: MenuIconAddCustomers 
    },
    { name: "Manage customers",       icon: MenuIconManageCustomers },
    // … eventueel meer items
  ];

  const EP_menuItems = [
    { name: "Connection and Security", icon: MenuIconConnection },
    { name: "General settings",       icon: MenuIconGeneral    },
    { 
      name: user?.autoLogin ? "Add employees" : "Invite employees", 
      icon: MenuIconAddCustomers 
    },
    { name: "Manage employees",       icon: MenuIconManageCustomers },
    // … eventueel meer items
  ];

  const SP_menuItems = [
    { name: "Connection and Security", icon: MenuIconConnection },
    { name: "General settings",       icon: MenuIconGeneral    },
    { 
      name: user?.autoLogin ? "Add suppliers" : "Invite suppliers", 
      icon: MenuIconAddCustomers 
    },
    { name: "Manage suppliers",       icon: MenuIconManageCustomers },
    // … eventueel meer items
  ];

  const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 10000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    borderRadius: '5px', // Afgeronde hoeken
  };
  
  const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
  const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };
  
  const menuContainerStyle = {
    display: 'flex',
    flexDirection: 'column',  // Dit zorgt ervoor dat de kinderen onder elkaar worden weergegeven
  };
  
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.1)', // semi-transparante achtergrond
    zIndex: 1000 // zodat het boven andere inhoud wordt weergegeven
  };
  

  const handleOverlayClick = () => {
    setMenu1Open(false);
    setMenu2Open(false);
    setShowOverlay(false);
  };
  
  useEffect(() => {
      if (isMenuOpen) {
          document.body.classList.add('menuOpen');
      } else {
          document.body.classList.remove('menuOpen');
      }
  }, [isMenuOpen]);
  
  function setSelectedReport(report) {
    setSelectedPBIReportId(report.PBI_report_id);
    setSelectedReportId(report.id);  // Voeg deze regel toe
    setSelectedPBIReport_UrlFilter(report.url_filter);
    setSelectedReportConnectedState(report.connected);
    setSelectedReportActiveState(report.active);
    setClickedMoreOptionsMenuReportId(report.report_id);

    localStorage.setItem('lastOpenedReport_PBI_Id', report.PBI_report_id);
    localStorage.setItem('lastOpenedReport_Id', report.id);
    localStorage.setItem('lastOpenedReport_Report_Id', report.report_id);
    localStorage.setItem('lastOpenedReport_Report_UrlFilter', report.url_filter);
  }

  useEffect(() => {
    const lastOpenedReport_PBI_Id = localStorage.getItem('lastOpenedReport_PBI_Id');
    const lastOpenedReport_Id = localStorage.getItem('lastOpenedReport_Id');
    const lastOpenedReport_Report_Id = localStorage.getItem('lastOpenedReport_Report_Id');
    const lastOpenedReport_Report_UrlFilter = localStorage.getItem('lastOpenedReport_Report_UrlFilter');
    
    if (lastOpenedReport_PBI_Id) {
      setSelectedPBIReportId(lastOpenedReport_PBI_Id);
      setSelectedPBIReport_UrlFilter(lastOpenedReport_Report_UrlFilter);
    }
    if (lastOpenedReport_Id) {
      setSelectedReportId(lastOpenedReport_Id);
      setSelectedPBIReport_UrlFilter(lastOpenedReport_Report_UrlFilter);
    }
    setClickedMoreOptionsMenuReportId(lastOpenedReport_Report_Id);
  }, []);

  const positionMoreOptionsReportMenu = (e, reportId) => {
    e.stopPropagation();
    setMoreOptionsReportMenuPosition({ x: e.pageX, y: e.pageY });
    setMoreOptionsReportMenuOpen(reportId);
    setClickedMoreOptionsMenuReportId(reportId);  // Geef reportId direct door
  };

  const handleMoreOptionsReportMenuClick = async (action) => {
    setClickedMoreOptionsMenuReportId(moreOptionsReportMenuOpen);

    if(action === 'edit') {
      try {
        // Pak de juiste IDs uit je context
        const companyId = user.default_companyid;
        const reportId  = clickedMoreOptionsReportId;
    
        // Voer de API-aanroep uit
        const { data, status } = await api.post('/api/editReport', {
          report_id: reportId,
          company_id: companyId
        });
    
        if (status === 200) {
          // Bouw je PowerBI URL en open in nieuw venster
          const urlToOpen = `https://app.powerbi.com/groups/${data.workspace_id}/reports/${data.report_PBI_id}?ctid=3cdc3671-b8ef-411a-bfa7-febdbe0bec95&experience=power-bi`;
          const newWindow = window.open(urlToOpen, '_blank', 'noopener,noreferrer');
          if (newWindow) newWindow.opener = null;
        }
      } catch (err) {
        if (err.response?.status === 401) {
          // Token verlopen: logout en redirect naar login
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
    
          navigate(`/login/${user.default_companyid}`);
        } else {
          // Andere fout
          console.error('Error editing report:', err);
          setError('Something went wrong during editing report');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      }
    } else if(action === 'configure') 
    {
      navigate(`/configcompanyreport/${clickedMoreOptionsReportId}`);
    } else if(action === 'update') 
    {
      setShowQuestionYesNoPopup_UpdateReport(true);
    }  else if(action === 'delete') 
    {
      setShowQuestionYesNoPopup(true);
    } else if(action === 'refresh') 
    {
      try {
        // 1) Doe de API-call via je axios-instance, cookies gaan automatisch mee
        await api.post('/api/refreshDataset', {
          report_id: clickedMoreOptionsReportId,
          company_id: companyId
        });
      
        // 2) Toon succes‐melding
        setMessage(
          "Dataset refresh initiated! Completion time varies from 5 to 60 minutes, depending on dataset size."
        );
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 6000);
      
      } catch (err) {
        // 3) Bij 401: sessie verlopen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId || ''}`);
          return;
        }
      
        // 4) Andere fout
        console.error('Error refreshing dataset:', err);
        setError(
          'Something went wrong during refreshing dataset: ' +
            (err.response?.data?.error || err.message)
        );
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }           
    }

    setShowOverlay(false);
    setMoreOptionsReportMenuOpen(false);  // Sluit het popup-menu
  };

  const reloadReport = () => {
    setReportSrc(''); // Eerst resetten om een herladen te forceren
    setTimeout(() => {
      const src = `https://app.powerbi.com/reportEmbed?reportId=${selectedPBIReportId}&autoAuth=true&ctid=3cdc3671-b8ef-411a-bfa7-febdbe0bec95&filter=${selectedPBIReport_UrlFilter}`;
      setReportSrc(src);
    }, 10);
  };

  // Deze functie activeert de licentie voor een rapport
  async function activateReport(cruId) {
    try {
      // PUT-aanroep via je axios-instance; credentials (cookies) gaan automatisch mee
      await api.put('/api/activate_report', { cru_id: cruId });

      // Bij succes toon je een informatieve boodschap
      setMessage(
        'Report license activated successfully! ' +
        'Please wait until the data is refreshed to experience full data access.'
      );
      setShowPopupMessage(true);
      setTimeout(() => setShowPopupMessage(false), 6000);

      // Update lokale component-state
      setSelectedReportActiveState(1);

    } catch (err) {
      // 401 → sessie verlopen: log uit en stuur terug naar login
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
        return;
      }

      // Andere fouten: lees de foutmelding uit de backend (indien aanwezig)
      const msg = err.response?.data?.error
        || 'Something went wrong activating report license';
      setError(msg);
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
    }
  }


    // Deze functie roept je backend API aan om te controleren of er nog een vrije user-licentie beschikbaar is
  async function checkLicenseStatus(cruId) {
    try {
      // POST via axios; cookies/token gaan automatisch mee
      const { data } = await api.post('/api/license_status', { cru_id: cruId });

      const { total_active_licenseusers, total_max_number_licenseusers } = data;

      // Bouw de tekst voor de bevestigings-popup
      let text = 'Are you sure you want to activate the report?';
      if (total_max_number_licenseusers === 0) {
        text = 'Are you sure you want to activate the report? ' +
               'Please be aware that activating this report will add a license and incur additional costs.';
      } else if (total_active_licenseusers >= total_max_number_licenseusers) {
        text = 'Are you sure you want to activate the report? ' +
               'Please be aware that activating this report will add a new license and incur additional costs.';
      }

      setPopupLicenseText(text);
      setShowQuestionYesNoPopup_ActivateLicense(true);

    } catch (err) {
      // 401 → sessie verlopen: uitloggen en terug naar login
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
        return;
      }

      // Andere fouten: lees de foutmelding uit de response of val terug op generiek
      const msg = err.response?.data?.error
        || 'Something went wrong';
      setError(msg);
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
    }
  }

    const videoRef = useRef();

    useEffect(() => {
      if (videoRef.current) {
        videoRef.current.load();
      }
    }, [selectedVideo]); // Afhankelijkheid van selectedVideo


  function SideMenu(props) {
    const { expanded } = props;

    const menuRef = useRef(); // Ref voor het menu
    const [bounce, setBounce] = useState(false);
    
    const triggerBounce = () => {
        setBounce(true);
        // Schakel de bounce state na de animatie weer uit
        setTimeout(() => setBounce(false), 500); // Duur van de animatie
    };

    // Functie om te bepalen of de klik buiten het contextmenu was
    const handleClickOutside_SideMenu = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMoreOptionsReportMenuOpen(false);
      }
    };

    // Voeg event listeners toe wanneer de component wordt gemount en verwijder ze wanneer de component wordt ge-unmount
    useEffect(() => {
      document.addEventListener('click', handleClickOutside_SideMenu);
      return () => {
        document.removeEventListener('click', handleClickOutside_SideMenu);
      };
    }, []);

    const handleAddReportClick = async (updateItem, removeItemValue) => {
      // 1) Als er geen nieuwe rapportnamen zijn: direct naar /addreport
      if (!newReportNames || newReportNames.length === 0) {
        navigate('/addreport');
        return;
      }
  
      try {
        // 2) API-aanroep via axios; cookies/token gaan automatisch mee
        await api.post('/api/updateUser_newStatus', {
          user_id:          user.id,
          updateItem,
          removeItemValue
        });
  
        // 3) Succes: navigeer naar addreport
        navigate('/addreport');
  
      } catch (err) {
        // 4) 401 → sessie verlopen: uitloggen en terug naar inlogpagina
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId || ''}`);
          return;
        }
  
        // 5) Andere fouten: toon foutmelding
        console.error('Something went wrong during updating user:', err);
        const msg = err.response?.data?.error || 'Something went wrong';
        setError(msg);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    };  
    
    
    const renderAnalysesContent = () => {
      return (
        <div className="content">
          {myDashboards.value && myDashboards.value.length > 0 && (
            <>
              <h3 style={{ visibility: expanded ? 'visible' : 'hidden' }}>
                <b>{ expanded ? 'My dashboards' : 'MD' }</b>
              </h3>
              <ul>
                  {myDashboards.value.map((dashboard, index) => 
                      <li key={index} onClick={() => {
                          setSelectedDashboardId(dashboard.id);
                          setSelectedDashboardUrl(dashboard.webUrl); // Sla de webUrl op
                          setSelectedPBIReportId(null); // Zorg ervoor dat er geen rapport geselecteerd is
                      }}>
                            <div className="report-content" title={dashboard.displayName} style={{cursor: 'pointer'}}>
                              <span role="img" aria-label="report-icon">📄</span> 
                              {dashboard.displayName}
                          </div>
                      </li>
                  )}
              </ul>
            </>
          )}
          <h3 style={{ visibility: expanded ? 'visible' : 'hidden' }}>
            <b>{ expanded ? 'My reports' : 'MR' }</b>
          </h3>
          <ul>
          {myReports.map(report => 
              <li 
                  key={report.id} 
                  onClick={() => {
                    if (report.visible !== 0) {
                      // Als hetzelfde rapport opnieuw wordt geklikt, herladen we de gegevens
                      if (report.PBI_report_id === selectedPBIReportId) {
                        // Voer de logica uit om het rapport te herladen, bijvoorbeeld:
                        reloadReport(report.PBI_report_id); // Implementeer deze functie dienovereenkomstig
                      }
                      setSelectedReport(report);
                    }

                    triggerBounce();
                  }}
                  className={`report-item ${report.PBI_report_id === selectedPBIReportId ? 'active-report' : ''} ${report.visible === 0 ? 'greyed-out' : ''}`}
              >
              <div
                className="report‐row"  /* zorg dat deze class de flex-container is */
                title={report.report_name}
              >
                {/* Icoon altijd renderen */}
                <img
                  src={MenuIconBIReport}
                  alt="Report icon"
                  className="report-icon"
                  style={{
                    marginRight: expanded ? '10px' : '0',
                    height: '25px',
                    flexShrink: 0  /* voorkomt dat het icoon krimpt */
                  }}
                />

                {/* Alleen de tekst weergave als expanded === true */}
                {expanded && (
                  <span className="report‐content">
                    {report.report_name}
                  </span>
                )}
              </div>
                  {expanded && report.visible === 0 && (
                      <img 
                          src={icon_Warning}
                          alt="Warning icon" 
                          className="warning-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowWarningPopup(true)
                          }}
                      />
                  )}
                  {expanded && report.PBI_report_id === selectedPBIReportId && (
                      <div style={{ justifyContent: 'space-between' }}>
                          <img 
                              src={icon_MoreOptions} 
                              alt="More Options Report" 
                              title="More options" 
                              className="selected-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowOverlay(true);
                                positionMoreOptionsReportMenu(e, report.report_id);
                              }}                              
                          />
                      </div>
                  )}
              </li>
          )}
          </ul>
            <div
              ref={contextMenuRef}
              className={`context-menu${moreOptionsReportMenuOpen ? ' open' : ''}`}
              style={{
                top: moreOptionsReportMenuPosition.y,
                left: moreOptionsReportMenuPosition.x,
                position: 'fixed',
                zIndex: 1001
              }}
            >
            <ul>
              {user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                <li onClick={() => handleMoreOptionsReportMenuClick('refresh')}>
                  <img src={icon_Refresh} className="selected-icon" title="Refresh dataset" alt="Refresh dataset" />
                  <span className="menu-text">Refresh dataset</span>
                </li>
              )}
              {user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                <li onClick={() => handleMoreOptionsReportMenuClick('edit')}>
                  <img src={icon_EditReport} className="selected-icon" title="Edit report" alt="Edit report" />
                  <span className="menu-text">Edit report</span>
                </li>
              )}
              
              {user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                <li onClick={() => handleMoreOptionsReportMenuClick('configure')}>
                  <img src={icon_ConfigCompany} className="selected-icon" title="Configure report" alt="Configure report" />
                  <span className="menu-text">Configure report</span>
                </li>
              )}
              {/* 10-1-2025: 'Update report' nog niet activeren, omdat de functionaliteit eerst nog goed getest moet worden (nog niet stabiel)
              {myReports.map(report => (
                report.PBI_report_id === selectedPBIReportId && (
                  <li 
                    key={report.id} 
                    style={{
                      color: report.report_current_version === report.report_newest_version ? 'grey' : 'inherit',
                      cursor: report.report_current_version === report.report_newest_version ? 'default' : 'pointer',
                    }}
                    onClick={() => {
                      if (report.report_current_version !== report.report_newest_version) {
                        handleMoreOptionsReportMenuClick('update');
                      }
                    }}
                  >
                    <img
                      src={icon_UpdateReport}
                      className="selected-icon"
                      style={{
                        cursor: report.report_current_version === report.report_newest_version ? 'default' : 'pointer',
                      }}
                      alt="Update report"
                    />
                    <span className="menu-text" style={{color: report.report_current_version === report.report_newest_version ? 'grey' : 'inherit'}}>Update report</span>
                  </li>
                )
              ))}
                */}
              <li onClick={() => handleMoreOptionsReportMenuClick('delete')}>
                <img src={icon_DeleteReport} className="selected-icon" title="Delete report" alt="Delete report" />
                <span className="menu-text">Delete report</span>
              </li>
            </ul>
          </div>
        </div>
      );
    };

    const renderCustomApplicationModulesContent = () => {
      return (
        <div className="content">
          <h3 style={{ visibility: expanded ? 'visible' : 'hidden' }}>
            <b>{ expanded ? 'Ridder iQ' : 'RIQ' }</b>
          </h3>
          <ul>
            {modules.map((module, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelectedVideo(module.videoSrc);
                  setSelectedModule(module.name); // Update de geselecteerde module
                  handleSetNewItemsClick('AppModules', module.name);

                  triggerBounce();
                }}
                className={`report-item ${module.name === selectedModule ? 'active-report' : ''}`}
                style={{cursor: 'pointer'}}
              >
                {module.name}
                {newAppModuleNames.includes(module.name) && 
                  <div className="new-indicator-container">
                    <span className="new-indicator" style={{ color: 'white'}}>New</span>
                  </div>
                }
              </li>
            ))}
          </ul>
        </div>
      );
    };
    
    const renderAppsInSideMenu = () => {
      // user, companyName, selectedAppItem, menu1Open, setMenu1Open, closeMenu1, icon1, icon_Analyses,
      // icon_CustomApplicationModules, icon_CustomerPortal, newAppNames, newAppModuleNames,
      // setSelectedAppItem, handleSetNewItemsClick, setSelectedCP_MenuItem, popupMenuStyle
      // komen uit de bovenliggende scope (bijv. Header of SideMenu).

      return (
        <div style={{ position: 'relative', marginBottom: '10px' }}>
          {/* 1) Apps‐icoon */}
          <div
            ref={iconRef}
            className="menu-item"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: expanded ? 'flex-start' : 'center',
              cursor: 'pointer',
              padding: expanded ? '5px 15px' : '5px 0',
            }}
            onClick={handleMenu1Click}
          >
            <img
              src={icon1}
              alt="Apps"
              style={{ height: '3vh', marginRight: expanded ? '10px' : '0' }}
              title="Apps"
            />
            {expanded && (
              <span style={{ fontSize: '1rem', color: 'inherit', fontWeight: 'bold' }}>
                {selectedAppItem}
              </span>
            )}
          </div>

          {/* 2) De dropdown alleen renderen als menu1Open === true */}
          {menu1Open && (
            <div
              ref={menu1Ref}
              className="header-popup open"
              style={{
                ...popupMenuStyle,
                position: 'fixed',
                zIndex: 1000,
                left: `${popupCoords.left}px`,
                top: `${popupCoords.top-250}px`,
                zIndex: 1100,
                // Verwijder hier eventuele “right” of “bottom” instellingen
              }}
            >
              <div style={{ color: 'grey', marginBottom: '5px' }}>APPS</div>

              {/* Analyses */}
              {((user.company_roleId <= 3) || user.company_roleId === 5) && companyName && (
                <div
                  className="menu-item"
                  onClick={() => {
                    localStorage.setItem('iA-App', 'Analyses');
                    setSelectedAppItem('Analyses');
                    closeMenu1();
                  }}
                >
                  <div style={menuItemStyle}>
                    <img
                      src={icon_Analyses}
                      alt="Analyses"
                      style={{ height: '3vh', margin: '0px 10px 0px 0px' }}
                    />
                    Analyses
                  </div>
                </div>
              )}

              {/* Custom Application Add-ons */}
              {user.company_roleId <= 3 && companyName && (
                <div
                  className="menu-item"
                  onClick={() => {
                    localStorage.setItem('iA-App', 'Custom Application Add-ons');
                    setSelectedAppItem('Custom Application Add-ons');
                    handleSetNewItemsClick('Apps', 'Custom Application Add-ons');
                    closeMenu1();
                  }}
                >
                  <div style={menuItemStyle}>
                    <img
                      src={icon_CustomApplicationModules}
                      alt="Custom Application Modules"
                      style={{ height: '3vh', margin: '0px 10px 0px 0px' }}
                    />
                    Custom Application Add-ons
                    {newAppNames.includes('Custom Application Add-ons') ? (
                      <span className="new-indicator">New</span>
                    ) : (
                      user.company_roleId <= 3 &&
                      newAppModuleNames &&
                      newAppModuleNames.length > 0 && (
                        <span
                          className="new-indicator"
                          style={{ top: '-5px', fontSize: '12px' }}
                        >
                          New [{newAppModuleNames.length}]
                        </span>
                      )
                    )}
                  </div>
                </div>
              )}

              {/* Scheidingslijn */}
              <div
                style={{
                  borderBottom: '1px solid lightgrey',
                  margin: '10px 15px',
                }}
              />

              {/* Customer Portal */}
              {user.company_roleId <= 2 && companyName && (
                <div
                  className="menu-item"
                  onClick={() => {
                    localStorage.setItem('iA-App', 'Customer Portal');
                    setSelectedAppItem('Customer Portal');
                    setSelectedCP_MenuItem('Connection and Security');
                    closeMenu1();
                  }}
                >
                  <div style={menuItemStyle}>
                    <img
                      src={icon_CustomerPortal}
                      alt="Customer Portal"
                      style={{ height: '3vh', margin: '0px 10px 0px 0px' }}
                    />
                    Customer Portal
                  </div>
                </div>
              )}

              {/* Hier kun je nog meer items toevoegen indien nodig */}
            </div>
          )}
        </div>
      );
    };


    return (
      <div className={`side-menu ${expanded ? 'expanded' : 'collapsed'}`} ref={menuRef}>
        <div className="button-container-sm">
          {selectedAppItem === 'Analyses' && user?.company_roleId <= 3 && expanded && (
            <div>
              <button className="addReportButton" style={{ width: user?.autoLogin ? '135px' : '180px' }} onClick={() => handleAddReportClick("Reports", "")}>+ Add report</button>
              {newReportNames && newReportNames.length > 0 && <span className="badge-new-report">New report</span>}
            </div>
          )}
          {user?.company_roleId === 4 && (
            <div style={{ width: '180px', height: 'auto', display: 'block' }} />
          )}

          {expanded && user?.autoLogin && user.company_roleId <= 2 && (
            <button
              className="menuButton-sm"
              onClick={() => navigate('/configcompany')}
              style={{
                marginRight: '45px',
                padding: '4px',
              }}
            >
              <img
                src={icon_ConfigCompany}
                alt="Configure company"
                title="Configure company"
                style={{ height: '18px', width: '18px', display: 'block' }}
              />
            </button>
          )}
          <button className="menuButton-sm" onClick={props.toggleMenu}>
            <img src={toggle_menu_icon} alt="Shrink menu" />
          </button>
        </div>

        {selectedAppItem === 'Analyses' && (user?.company_roleId <= 3 || user?.company_roleId === 5) && renderAnalysesContent()}
        {selectedAppItem === 'Custom Application Add-ons' && user?.company_roleId <= 3 && renderCustomApplicationModulesContent()}

        {/* Configuratiepagina voor Customer Portal (rol <= 3) */}
        {selectedAppItem === 'Customer Portal' && user?.company_roleId <= 3 && (
          <CustomerPortal
            mode="config"
            expanded={expanded}
            CP_menuItems={CP_menuItems}
            selectedCP_MenuItem={selectedCP_MenuItem}
            setSelectedCP_MenuItem={setSelectedCP_MenuItem}
          />
        )}
        {/* Gebruikersmenu voor Customer Portal (rol 4) */}
        {selectedAppItem === 'Customer Portal' && user?.company_roleId === 4 && (
          <CP_UserPermissionsProvider>
            <CustomerPortal
              mode="user"
              expanded={expanded}
              selectedCP_MenuItem={selectedCP_MenuItem}
              setSelectedCP_MenuItem={setSelectedCP_MenuItem}
              setModuleContent={setModuleContent}
            />
          </CP_UserPermissionsProvider>
        )}

        {/* Configuratiepagina voor Employee Portal (rol <= 2) */}
        {selectedAppItem === 'Employee Portal' && user?.company_roleId <= 2 && (
          <EmployeePortal
            mode="config"
            expanded={expanded}
            EP_menuItems={EP_menuItems}
            selectedEP_MenuItem={selectedEP_MenuItem}
            setSelectedEP_MenuItem={setSelectedEP_MenuItem}
          />
        )}
        {/* Gebruikersmenu voor Employee Portal (rol 3 of rol 5) */}
        {selectedAppItem === 'Employee Portal' && (user?.company_roleId === 3 || user?.company_roleId === 5) && (
          <EP_UserPermissionsProvider>
            <EmployeePortal
              mode="user"
              expanded={expanded}
              selectedEP_MenuItem={selectedEP_MenuItem}
              setSelectedEP_MenuItem={setSelectedEP_MenuItem}
              setModuleContent={setModuleContent}
            />
          </EP_UserPermissionsProvider>
        )}

        {/* Configuratiepagina voor Supplier Portal (rol <= 3) */}
        {selectedAppItem === 'Supplier Portal' && user?.company_roleId <= 3 && (
          <SupplierPortal
            mode="config"
            expanded={expanded}
            SP_menuItems={SP_menuItems}
            selectedSP_MenuItem={selectedSP_MenuItem}
            setSelectedSP_MenuItem={setSelectedSP_MenuItem}
          />
        )}
        {/* Gebruikersmenu voor Supplier Portal (rol 6) */}
        {selectedAppItem === 'Supplier Portal' && user?.company_roleId === 6 && (
          <SP_UserPermissionsProvider>
            <SupplierPortal
              mode="user"
              expanded={expanded}
              selectedSP_MenuItem={selectedSP_MenuItem}
              setSelectedSP_MenuItem={setSelectedSP_MenuItem}
              setModuleContent={setModuleContent}
            />
          </SP_UserPermissionsProvider>
        )}


        { selectedAppItem == 'Analyses' && user?.company_roleId && user?.company_roleId !== 3 && user?.company_roleId && user?.company_roleId < 4 && companyName && selectedReportConnectedState !== 1 && expanded && (
            <div>
                <div style={{ height: '20px'}} ></div>
                <div className={`button-container-sm ${bounce ? 'bounce-effect' : ''}`}>
                    <button className="invite-user-button" style={{ fontSize: '14px' }} onClick={() => handleMoreOptionsReportMenuClick('configure')}>
                        Click here to setup the connection to your own data!
                    </button>
                </div>
            </div>
        )}
        { selectedAppItem == 'Analyses' && user?.company_roleId && user?.company_roleId !== 3 && user?.company_roleId && user?.company_roleId < 4 && companyName && selectedReportConnectedState === 1 && selectedReportActiveState !== 1 && expanded && (
            <div>
                <div style={{ height: '20px'}} ></div>
                <div className={`button-container-sm ${bounce ? 'bounce-effect' : ''}`}>
                    <button className="invite-user-button" style={{ fontSize: '14px' }} onClick={() => checkLicenseStatus(selectedReportId)}>
                        Click here to activate your license for full data access!
                    </button>
                </div>
            </div>
        )}

        {expanded && <div className="side-menu-separator"></div>}
        {/* ───── NU de separator en teksten of de Apps‐knop ───── */}
        {user?.autoLogin && user.company_roleId <= 3 ? (
          // Als autoLogin === true: toon alleen “Apps‐icoon + dropdown”
          renderAppsInSideMenu()
        ) : (
          // Anders: toon de originele separator en onderliggende tekst
          <>

            {selectedAppItem === 'Analyses' && expanded && <p>Analyses</p>}
            {selectedAppItem === 'Custom Application Add-ons' && expanded && <p>Custom Application Add-ons</p>}
            {selectedAppItem === 'Customer Portal' && expanded && <p>Customer Portal</p>}
            {selectedAppItem === 'Employee Portal' && expanded && <p>Employee Portal</p>}
            {selectedAppItem === 'Supplier Portal' && expanded && <p>Supplier Portal</p>}
          </>
        )}
      </div>
      );
    }

  // Deze functie roept je backend API aan om een rapport te verwijderen
  async function deleteReport(cruId) {
    try {
      // 1) API-call via axios; cookies/token gaan automatisch mee
      await api.post('/api/deleteSelectedReports', {
        cru_id:     cruId,
        company_id: companyId
      });

      // 2) (optioneel) hier kun je bijv. je lijst opnieuw laden of een succes-melding tonen

    } catch (err) {
      // 3) 401 → sessie verlopen: uitloggen en terug naar login
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
        return;
      }

      // 4) Andere fouten: gooi een English error of toon het
      const msg = err.response?.data?.error || 'Something went wrong during deleting report';
      console.error('Delete report error:', msg);
      setError(msg);
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
    }
  }

  // Deze functie roept je backend API aan om een rapport te updaten
  async function updateReport(cruId) {
    try {
      // 1) Maak de call via je axios-instance; sessiecookie/token gaan automatisch mee
      const { data } = await api.post('/api/updateSelectedReports', {
        cru_id:     cruId,
        company_id: companyId
      });

      // 2) Backend geeft op success de boodschap in data.message terug
      return data.message;

    } catch (err) {
      // 3) Bij 401: sessie verlopen → uitloggen en naar login
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
        return;
      }

      // 4) Andere errors: toon de originele Engelse foutboodschap
      const msg = err.response?.data?.error
                || 'Something went wrong during updating report';
      console.error('Update report error:', msg);
      setError(msg);
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
      throw new Error(msg);
    }
  }


  async function handleDeleteSelectedReport() {
    try {
      // 1) Zoek het geselecteerde rapport uit je state
      const selectedReport = myReports.find(
        (r) => r.PBI_report_id === selectedPBIReportId
      );
      if (!selectedReport) {
        console.warn("Rapport niet gevonden");
        return;
      }
      const companyReportsId = selectedReport.id;

      // 2) Verwijder het rapport via je aangepaste deleteReport()
      await deleteReport(companyReportsId, companyId);

      // 3) Toon succesmelding
      setMessage("Report deleted successfully!");
      setShowPopupMessage(true);
      setTimeout(() => setShowPopupMessage(false), 3000);

      // 4) Haal de lijst opnieuw op via axios
      const { data } = await api.get(
        `/api/myreports/${user.id}/${companyId}`
      );
      setMyReports(data.reports || []);

    } catch (err) {
      // 5) Bij 401: sessie verlopen → uitloggen en redirect
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
        return;
      }

      // 6) Overige fouten tonen
      console.error("Something went wrong during deleting report:", err);
      setError('Something went wrong during deleting report: ' + (err.message || err));
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
    }
  }

  async function handleUpdateSelectedReport() {
    setIsLoading(true);

    try {
      // 1) Vind het geselecteerde rapport uit je state
      const selectedReport = myReports.find(
        (r) => r.PBI_report_id === selectedPBIReportId
      );
      if (!selectedReport) {
        console.warn("Report not found");
        setIsLoading(false);
        return;
      }

      // 2) Haal het interne ID
      const companyReportsId = selectedReport.id;

      // 3) Roep je helper aan om te updaten
      const successMessage = await updateReport(companyReportsId);
      setMessage(successMessage);
      setShowPopupMessage(true);
      setTimeout(() => setShowPopupMessage(false), 3000);

      // 4) Na de update: herlaad de lijst via axios
      const { data } = await api.get(
        `/api/myreports/${user.id}/${companyId}`
      );
      setMyReports(data.reports || []);

    } catch (err) {
      // 5) Bij 401: sessie verlopen → uitloggen en redirect
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
      } else {
        // 6) Andere fouten tonen
        console.error("Something went wrong during updating report:", err);
        const msg = err.message || 'Something went wrong during updating report';
        setError(msg);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // Alleen starten als user en companyId geladen zijn
    if (!user?.id || !companyId) return;

    // Zet je App/Module/Report namen uit de user-context
    const { newAppName, newAppModuleName, newReportName } = user;
    setNewAppNames(newAppName       ? newAppName.split(';')           : []);
    setNewAppModuleNames(newAppModuleName ? newAppModuleName.split(';') : []);
    setNewReportNames(newReportName  ? newReportName.split(';')         : []);

    // Haal reports & dashboards op
    const fetchReports = async () => {
      try {
        const { data } = await api.get(
          `/api/myreports/${user.id}/${companyId}`
        );
        setMyReports(data.reports);
        setMyDashboards(data.dashboards);
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId}`);
          return;
        }

        // andere errors
        console.error('Error fetching reports:', err);
        setError('Error fetching reports: ' +
          (err.response?.data?.error || err.message));
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    };

    fetchReports();
  }, [user, companyId, logout, navigate]);

  useEffect(() => {
 }, [newAppNames]); // Deze useEffect zal uitvoeren wanneer newAppModuleNames verandert

  useEffect(() => {
  }, [newAppModuleNames]); // Deze useEffect zal uitvoeren wanneer newAppModuleNames verandert

  useEffect(() => {
  }, [newReportNames]); // Deze useEffect zal uitvoeren wanneer newAppModuleNames verandert
  
  const toggleSideMenu = () => {
    setIsMenuExpanded(prev => !prev);
  };

  const handleLogout = async () => {
    // 1) Roep de server-side logout aan en clear de React-context
    await logout();
  
    // 2) Redirect naar login, met de actieve companyId uit context
    navigate(`/login/${companyId || ''}`);
  };
 

  const handleMyProfile = () => {
    navigate('/my-profile');
  };

  const handleSwitchCompany = () => {
    navigate('/my-companies');
  };

  const handleClickOutside = (event) => {
    if (menu1Ref.current && !menu1Ref.current.contains(event.target)) {
      setMenu1Open(false);
      setShowOverlay(false);
    }
    if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
      setMenu2Open(false);
      setShowOverlay(false);
    }
  };
  
  const handleMenu1Click = (e) => {
    e.stopPropagation(); // voorkom dat evt. een buiten‐klik‐handler gesloten wordt

    if (!menu1Open && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      // Zet popupCoords zó dat de dropdown begint op de rechteronderhoek van het icoon
      setPopupCoords({
        left: Math.round(rect.right), // x‐coördinaat in pixels
        top: Math.round(rect.bottom)  // y‐coördinaat in pixels
      });
    }
    setShowOverlay(true);
    setMenu1Open(open => !open);
  };


  const closeMenu1 = () => {
    setMenu1Open(false);
    setShowOverlay(false);
  };

  const handleMenu2Click = () => {
    setMenu2Open(true);
    setShowOverlay(true);
  };
  
  const handleMenu_Help = () => {
    setShowHelpPopup(true);
  };

  const handleMyTrainings = () => {
    navigate('/my-trainings');
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (menu1Ref.current && !menu1Ref.current.contains(event.target)) {
        setMenu1Open(false);
      }
      if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
        setMenu2Open(false);
      }
      if (contextMenuRef.current
          && !contextMenuRef.current.contains(event.target)
          && moreOptionsReportMenuOpen) {
        setMoreOptionsReportMenuOpen(null);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    // Opruimen bij ontkoppeling
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // Geen afhankelijkheden, alleen bij mounten en ontkoppelen


  // 1) Bij component-mount: zorg dat companyId/companyName uit context klopt,
  //    anders fallback: haal de default-company via de backend op.
  useEffect(() => {
    // Als we al een companyId + companyName in Context hebben: niks doen
    if (companyId && companyName) return;

    // Anders: kijk of de ingelogde user een default_companyid heeft
    const defaultId = user?.default_companyid;
    if (!defaultId) {
      // Geen default_companyid → geen actieve company
      return;
    }

    // Fallback: laad de company-gegevens van de backend
    (async () => {
      try {
        const res = await api.get(`/api/companies/${defaultId}`);
        const { company_id, company_name } = res.data;

        // Vul context via de switchCompany-functie uit AuthContext
        switchCompany(company_id, company_name);

      } catch (err) {
        console.error('Error loading default company:', err);
        setError('Error loading default company');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);

        // Als het een 401 is, log dan uit en stuur terug naar login
        if (err.response?.status === 401) {
          await logout();
          navigate(`/login/${defaultId}`);
        }
      }
    })();
  }, [user, companyId, companyName, switchCompany, logout, navigate]);

  useEffect(() => {
    if (selectedPBIReportId) {
      const src = `https://app.powerbi.com/reportEmbed?reportId=${selectedPBIReportId}&autoAuth=true&ctid=3cdc3671-b8ef-411a-bfa7-febdbe0bec95&filter=${selectedPBIReport_UrlFilter}`;
      setReportSrc(src);
    }
  }, [selectedPBIReportId]);
  
 
  // Als de gebruiker niet is ingelogd, render dan niets
  if (!user) 
  {
    //navigate('/login/'+companyId); // Redirect naar de loginpagina // Redirect naar de loginpagina
    return null;
  }
  
  const handleSetNewItemsClick = async (updateItem, removeItemValue) => {
    // 1) Zorg dat er überhaupt nieuwe items in context zijn
    if (updateItem === 'Apps' && (!newAppNames || newAppNames.length === 0)) {
      return;
    }
    if (updateItem === 'AppModules' && (!newAppModuleNames || newAppModuleNames.length === 0)) {
      return;
    }

    try {
      // 2) Roep je backend aan via axios-instance
      await api.post('/api/updateUser_newStatus', {
        user_id:       user.id,
        updateItem,
        removeItemValue
      });

      // 3) Bij succes: pas de context-gebruiker aan
      if (updateItem === 'Apps') {
        // filter de oude app-namen
        const filtered = newAppNames.filter(name => name !== removeItemValue);
        // update zowel context.user.newAppName als je lokale state
        updateUser({ newAppName: filtered.join(';') });
        setNewAppNames(filtered);
      } else if (updateItem === 'AppModules') {
        const filtered = newAppModuleNames.filter(name => name !== removeItemValue);
        updateUser({ newAppModuleName: filtered.join(';') });
        setNewAppModuleNames(filtered);
      }

    } catch (err) {
      // 4) 401 → sessie verlopen
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId || ''}`);
        return;
      }
      // 5) overige fouten
      const msg = err.response?.data?.error || err.message;
      console.error('Something went wrong:', msg);
      setError(msg);
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
    }
  };


  return (
    <div className="Main">
        {
            <SideMenu expanded={isMenuExpanded} toggleMenu={toggleSideMenu} />
        }

        <div className="contentContainer" style={{ width: isMenuExpanded ? 'calc(100vw - 250px)' : 'calc(100vw - 70px)' }}>

          {/* header alleen tonen als autoLogin false of undefined */}
          { !user?.autoLogin && (
          <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #373187', height: '8.5vh'}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {logoPath && (
                  <img 
                    src={logoPath} 
                    alt="Company logo" 
                    onError={handleImageError} 
                    style={{ height: '5vh', marginLeft: '10px', marginRight: '15px', marginTop: '15px', marginBottom: '15px' }} 
                  />
                )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                {user?.company_roleId && user?.company_roleId < 4 && <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />}
                {/* <div className={`headermenu-icon ${newAppNames && newAppNames.length > 0 ? 'pulse-animation' : ''}`} onClick={handleMenu1Click}> */}
                <div className={`headermenu-icon ${newAppNames && newAppNames.length > 0 ? '' : ''}`} onClick={handleMenu1Click}>
                  {user?.company_roleId && ((user.company_roleId <= 3) || (user.company_roleId === 5)) && <img src={icon1} className="selected-icon-variant-2" alt="Menu 1" style={iconStyle} title="Apps" />}
                  {
                    user?.company_roleId <= 3 && newAppNames && newAppNames.length > 0
                      ? <span className="badge">New App</span>
                      : user?.company_roleId <= 3 && newAppModuleNames && newAppModuleNames.length > 0
                        ? <span className="badge-new-appmodule">New [{newAppModuleNames.length}]</span>
                        : null
                  }
                </div>

                {/* Alleen renderen als autoLogin false is */}
                {!user?.autoLogin && (
                  <div ref={menu1Ref} className={`header-popup ${menu1Open ? 'open' : ''}`} style={{ ...popupMenuStyle, right: '40px', top: '8vh' }}>
                    <div style={{ color: 'grey', marginBottom: '5px' }}>APPS</div>
                    <div className='menu-item' onClick={() => { localStorage.setItem('iA-App', 'Analyses'); setSelectedAppItem('Analyses'); closeMenu1(); }}>
                      {((user.company_roleId <= 3) || (user.company_roleId === 5)) && companyName && (
                          <div style={menuItemStyle}><img src={icon_Analyses} alt="Analyses" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} />Analyses</div>
                      )}
                    </div>
                    {/*
                    {(user.company_roleId <= 3) && companyName && (
                      <div className='menu-item' onClick={handleMyTrainings}>
                        <div style={menuItemStyle}><img src={icon_Trainings} alt="Trainings" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} />Trainings</div>
                      </div>
                    )}
                    */}
                    {(user.company_roleId <= 3) && companyName && (
                      <div className='menu-item'  onClick={() => { localStorage.setItem('iA-App', 'Custom Application Add-ons'); setSelectedAppItem('Custom Application Add-ons'); handleSetNewItemsClick('Apps', 'Custom Application Add-ons'); closeMenu1(); }}>
                        <div style={menuItemStyle}>
                          <img src={icon_CustomApplicationModules} alt="Custom Application Modules" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> 
                          Custom Application Add-ons
                          {
                            newAppNames.includes("Custom Application Add-ons")
                              ? <span className="new-indicator">New</span>
                              : user?.company_roleId <= 3 && newAppModuleNames && newAppModuleNames.length > 0
                                ? <span className="new-indicator" style={{top: '-5px', fontSize: '12px' }}>New [{newAppModuleNames.length}]</span>
                                : null
                          }
                        </div>
                      </div>
                    )}

                      {/* 🔽 Scheidingslijn hier toevoegen */}
                      <div style={{ borderBottom: '1px solid lightgrey', margin: '10px 15px' }}></div>

                      {
                        user?.company_roleId && user?.company_roleId <= 2 && companyName && (
                        <div 
                          className='menu-item' 
                          onClick={() => { localStorage.setItem('iA-App', 'Customer Portal'); setSelectedAppItem('Customer Portal'); setSelectedCP_MenuItem('Connection and Security'); closeMenu1(); }}
                          //style={user?.id !== 45 ? { pointerEvents: 'none', opacity: 0.5 } : {}}  // Vooralsnog is de knop alleen actief als userId 45 is (SuperAdmin), voor demo-doeleinden
                        >
                              <div style={menuItemStyle}>
                                  <img src={icon_CustomerPortal} alt="Customer Portal" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> 
                                  Customer Portal
                              </div>
                        </div>
                        )
                      }
                      {
                      //  user?.company_roleId && ((user.company_roleId <= 3) || (user.company_roleId === 5)) && companyName && (
                      //  <div 
                      //    className='menu-item' 
                      //    onClick={() => { localStorage.setItem('iA-App', 'Employee Portal'); setSelectedAppItem('Employee Portal'); closeMenu1(); }}
                          //style={user?.id !== 45 ? { pointerEvents: 'none', opacity: 0.5 } : {}}  // Vooralsnog is de knop alleen actief als userId 45 is (SuperAdmin), voor demo-doeleinden
                      //  >
                      //        <div style={menuItemStyle}>
                      //            <img src={icon_EmployeePortal} alt="Employee Portal" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> 
                      //            Employee Portal
                      //        </div>
                      //  </div>
                      //  )
                      }
                      {
                        
                        user?.company_roleId && user?.company_roleId <= 2 && companyName && (
                        <div 
                          className='menu-item' 
                          onClick={() => { localStorage.setItem('iA-App', 'Supplier Portal'); setSelectedAppItem('Supplier Portal'); closeMenu1(); }}
                          //style={user?.id !== 45 ? { pointerEvents: 'none', opacity: 0.5 } : {}}  // Vooralsnog is de knop alleen actief als userId 45 is (SuperAdmin), voor demo-doeleinden
                        >
                              <div style={menuItemStyle}>
                                  <img src={icon_SupplierPortal} alt="Supplier Portal" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> 
                                  Supplier Portal
                              </div>
                        </div>
                        )
                        
                      }
                  </div>
                )}

                
                <img src={icon2} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={handleMenu2Click} />
                

                <div ref={menu2Ref} className={`header-popup ${menu2Open ? 'open' : ''}`} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                    <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                    <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                    <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                        {companyName || 'No company assigned'}
                        {
                          user?.company_roleId && user?.company_roleId !== 3 && user?.company_roleId && user?.company_roleId < 4 && companyName && (
                            <a href={`/configcompany`}>
                              <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                            </a>
                          )
                        }
                    </div>           
                    <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                    {user?.company_roleId && <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>}
                    {user?.company_roleId && <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>}
                    <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                </div>

            </div>
          </header>
          )}

          <main>
            {showOverlay && <div style={overlayStyle} onClick={handleOverlayClick}></div>}
            {selectedAppItem === 'Analyses' && user?.company_roleId && (user?.company_roleId < 4 || user?.company_roleId === 5) && (
                selectedDashboardId ? (
                    <iframe 
                        title="Power BI Dashboard" 
                        width="1140" 
                        height="541.25" 
                        src="https://app.powerbi.com/groups/221e8e7f-c367-447e-95ca-19a2b73599e5/dashboards/3b4d49a4-e57d-4f79-820b-33d8cb0cda00?experience=power-bi" //{selectedDashboardUrl} // Gebruik de opgeslagen webUrl
                        frameborder="0" 
                        allowFullScreen="true"
                    />
                ) : selectedPBIReportId ? (
                    <iframe 
                        title="Power BI Report" 
                        width="1140" 
                        height="541.25" 
                        src={reportSrc} 
                        frameborder="0" 
                        allowFullScreen="true"
                    />
                ) : (
                    <p style={{ margin: '20px' }}>Select or add a report or dashboard to view.</p>
                )
            )}

            {selectedAppItem === 'Custom Application Add-ons' && selectedVideo && user?.company_roleId && user?.company_roleId < 4 && (
              <div style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>Ridder iQ Demo Movie: Custom Add-on '{selectedModule}'</h2>
                <div className="video-container">
                  <video ref={videoRef} width="100%" controls>
                    <source src={selectedVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            )}



            {selectedAppItem === 'Customer Portal' && selectedCP_MenuItem === 'Connection and Security' && user?.company_roleId && user?.company_roleId <= 2 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                  <CPConnectionAndSecurity
                    user={user}
                  />
              </div>
            )}
            {selectedAppItem === 'Customer Portal' && selectedCP_MenuItem === 'General settings' && user?.company_roleId && user?.company_roleId <= 2 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                  <CPGeneralSettings
                    user={user}
                  />
              </div>
            )}
            {selectedAppItem === 'Customer Portal' && selectedCP_MenuItem === (user?.autoLogin ? 'Add customers' : 'Invite customers') && user?.company_roleId && user?.company_roleId < 4 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>{user?.autoLogin ? 'Add customers' : 'Invite customers'}</h2>
                <InviteCustomersTable />
              </div>
            )}
            {selectedAppItem === 'Customer Portal' && selectedCP_MenuItem === 'Manage customers' && user?.company_roleId && user?.company_roleId < 4 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>Manage customers</h2>
                <ManageInvitedCustomers />
              </div>
            )}
            {selectedAppItem === 'Customer Portal' && selectedCP_MenuItem === 'Data Subscriptions' && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>Data Subscriptions</h2>
                <Subscriptions  />
              </div>
            )}


            {selectedAppItem === 'Employee Portal' && selectedEP_MenuItem === 'Connection and Security' && user?.company_roleId && user?.company_roleId <= 2 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                  <EPConnectionAndSecurity
                    user={user}
                  />
              </div>
            )}
            {selectedAppItem === 'Employee Portal' && selectedEP_MenuItem === 'General settings' && user?.company_roleId && user?.company_roleId <= 2 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                  <EPGeneralSettings
                    user={user}
                  />
              </div>
            )}
            {selectedAppItem === 'Employee Portal' && selectedEP_MenuItem === (user?.autoLogin ? 'Add employees' : 'Invite employees') && user?.company_roleId && user?.company_roleId < 4 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>{user?.autoLogin ? 'Add employees' : 'Invite employees'}</h2>
                <InviteEmployeesTable />
              </div>
            )}
            {selectedAppItem === 'Employee Portal' && selectedEP_MenuItem === 'Manage employees' && user?.company_roleId && user?.company_roleId < 4 && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>Manage employees</h2>
                <ManageInvitedEmployees />
              </div>
            )}

            {selectedAppItem === 'Supplier Portal' && selectedSP_MenuItem === 'Connection and Security' && user?.company_roleId && user?.company_roleId <= 2 && (
              <div className="SP_DT-container" style={{ margin: '20px' }}>
                  <SPConnectionAndSecurity
                    user={user}
                  />
              </div>
            )}
            {selectedAppItem === 'Supplier Portal' && selectedSP_MenuItem === 'General settings' && user?.company_roleId && user?.company_roleId <= 2 && (
              <div className="SP_DT-container" style={{ margin: '20px' }}>
                  <SPGeneralSettings
                    user={user}
                  />
              </div>
            )}
            {selectedAppItem === 'Supplier Portal' && selectedSP_MenuItem === (user?.autoLogin ? 'Add suppliers' : 'Invite suppliers') && user?.company_roleId && user?.company_roleId < 4 && (
              <div className="SP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>{user?.autoLogin ? 'Add suppliers' : 'Invite suppliers'}</h2>
                <InviteSuppliersTable />
              </div>
            )}
            {selectedAppItem === 'Supplier Portal' && selectedSP_MenuItem === 'Manage suppliers' && user?.company_roleId && user?.company_roleId < 4 && (
              <div className="SP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>Manage suppliers</h2>
                <ManageInvitedSuppliers />
              </div>
            )}
            {selectedAppItem === 'Supplier Portal' && selectedSP_MenuItem === 'Data Subscriptions' && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <h2 style={{ color: 'gray' }}>Data Subscriptions</h2>
                <Subscriptions  />
              </div>
            )}

            {user?.company_roleId === 4 && selectedCP_MenuItem && moduleContent && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <CP_UserPermissionsProvider>
                  <CustomerPortalContent 
                    key={moduleContent.module_id} 
                    moduleContent={moduleContent}
                    selectedCP_MenuItem={selectedCP_MenuItem}
                    setModuleContent={setModuleContent}
                    standalone={false}
                  />
                </CP_UserPermissionsProvider>
              </div>
            )}

            {/* Voor user mode render je de dynamische inhoud */}
            {user?.company_roleId === 5 && selectedEP_MenuItem && moduleContent && (
              <div className="EP_DT-container" style={{ margin: '20px' }}>
                <EP_UserPermissionsProvider>
                  <EmployeePortalContent 
                    moduleContent={moduleContent}
                    selectedEP_MenuItem={selectedEP_MenuItem}
                  />
                </EP_UserPermissionsProvider>
              </div>
            )}

            {user?.company_roleId === 6 && selectedSP_MenuItem && moduleContent && (
              <div className="SP_DT-container" style={{ margin: '20px' }}>
                <SP_UserPermissionsProvider>
                  <SupplierPortalContent 
                    key={moduleContent.module_id} 
                    moduleContent={moduleContent}
                    selectedSP_MenuItem={selectedSP_MenuItem}
                    setModuleContent={setModuleContent}
                    standalone={false}
                  />
                </SP_UserPermissionsProvider>
              </div>
            )}

          </main>

          {showQuestionYesNoPopup_UpdateReport && (
            <div className="popup-container">
                <div className="popup-content">
                <h3 style={{ fontWeight: 'normal' }}>Are you sure you want to update the report? Custom changes and slicer settings will be lost</h3>
                <div className="white-space"></div>
                <div className="buttons-container">
                <button onClick={() => {
                    handleUpdateSelectedReport();
                    setShowQuestionYesNoPopup_UpdateReport(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    Yes
                </button>
                <button onClick={() => {
                    setShowQuestionYesNoPopup_UpdateReport(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    No
                </button>
                </div>
                {showCommentPopup && <div className="popup">{error}</div>}
                </div>
            </div>
          )}

          {showQuestionYesNoPopup && (
            <div className="popup-container">
                <div className="popup-content">
                <h3 style={{ fontWeight: 'normal' }}>Are you sure you want to delete the report?</h3>
                <div className="white-space"></div>
                <div className="buttons-container">
                <button onClick={() => {
                    handleDeleteSelectedReport();
                    setShowQuestionYesNoPopup(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    Yes
                </button>
                <button onClick={() => {
                    setShowQuestionYesNoPopup(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    No
                </button>
                </div>
                {showCommentPopup && <div className="popup">{error}</div>}
                </div>
            </div>
          )}

          {showQuestionYesNoPopup_ActivateLicense && (
            <div className="popup-container">
                <div className="popup-content">
                <h3 style={{ fontWeight: 'normal' }}>{popupLicenseText}</h3>
                <div className="white-space"></div>
                <div className="buttons-container">
                <button onClick={() => {
                    activateReport(selectedReportId);
                    setShowQuestionYesNoPopup_ActivateLicense(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    Yes
                </button>
                <button onClick={() => {
                    setShowQuestionYesNoPopup_ActivateLicense(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    No
                </button>
                </div>
                {showCommentPopup && <div className="popup">{error}</div>}
                </div>
            </div>
          )}

          {showWarningPopup && (
            <div className="popup-container">
                <div className="popup-content">
                <h3 style={{ fontWeight: 'normal' }}>You don't have access to view this report. Ask the administrator to provide access.</h3>
                <div className="white-space"></div>
                <div className="buttons-container">
                <button onClick={() => {
                    setShowWarningPopup(false);
                }} style={{ color: 'black', fontWeight: 'bold' }}>
                    Close
                </button>
                </div>
                {showCommentPopup && <div className="popup">{error}</div>}
                </div>
            </div>
          )}

          {showHelpPopup && (
            <div className="popup-container">
                <div className="popup-content">
                <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
                <div className="white-space"></div>
                <b>From:</b>
                <input
                    type="text"
                    placeholder="Username"
                    className="company-name-input"
                    disabled="true"
                    value={user.name || ""}
                />
                <b>Company:</b>
                <input
                    type="text"
                    placeholder="Company name"
                    className="company-name-input"
                    disabled="true"
                    value={companyName || ""}
                />
                <div style={{ display: 'inline-block', marginRight: '10px' }}>
                    <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                    <select 
                      style={{ display: 'inline-block', width: '150px' }}
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                      <option value="Support">Support</option>
                      <option value="Customization request">Customization request</option>
                  </select>
                </div>
                <div className="white-space"></div>
                <div className="white-space"></div>
                <b>Message:</b>
                <div className="white-space"></div>
                <textarea
                    placeholder="Request for support message"
                    className="company-name-input"
                    rows="4"
                    value={Request_message}
                    style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                    onChange={(e) => setRequestMessage(e.target.value)}
                ></textarea>
                <div style={{ height: '50px' }}></div>
                <div className="buttons-container">
                    <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                        Cancel
                    </button>
                    <button
                      //onClick={handleSendHelpButton}
                      style={{ color: 'black', fontWeight: 'bold' }}
                    >
                    Send request
                    </button>
                </div>
                </div>
            </div>
          )}

          {showPopupMessage && <div className="popup-message">{message}</div>}
          {showErrorPopup && <div className="popup">{error}</div>}
          {isLoading && 
              <div className="loader-wrapper">
              <div className="loader"></div>
              </div>
          }
        </div>
    </div>
  );
}

export default Header;
